import { StyleTemplateSidebarPanel } from "@/features/studio-ai/components/style-templates/style-template-sidebar-panel"
import { useStyleTemplateChatStore } from "@/features/studio-ai/stores/style-template-chat-store"
import { useStyleTemplateEditorStore } from "@/features/studio-ai/stores/style-template-editor-store"
import i18n from "@/languageConfig"
import { useContentSidebarStore } from "@/stores/content-sidebar-store"

export function openStyleTemplateInSidebar(): void {
  const title = i18n.t("studioAi.styleTemplates.title", {
    defaultValue: "Style Templates",
  })
  const unsavedTitle = i18n.t("canvas.unsaved_changes_title", { defaultValue: "Unsaved Changes" })
  const unsavedDescription = i18n.t("studioAi.styleTemplates.unsavedDescription", {
    defaultValue:
      "You have unsaved style template changes. If you leave now, your draft changes will be lost.",
  })
  const confirmLabel = i18n.t("canvas.close_anyway", { defaultValue: "Discard changes" })
  const cancelLabel = i18n.t("canvas.cancel", { defaultValue: "Stay" })

  useContentSidebarStore.getState().openPanel({
    id: "style-template-canvas",
    title,
    headerMode: "none",
    content: <StyleTemplateSidebarPanel />,
    focusable: false,
    closeable: true,
    resizable: true,
    isDirty: () => useStyleTemplateEditorStore.getState().isDirty,
    confirmMessage: {
      title: unsavedTitle,
      description: unsavedDescription,
      confirmLabel,
      cancelLabel,
    },
    onBeforeOpen: () => {
      useStyleTemplateEditorStore.getState().clearEditor()
      useStyleTemplateChatStore.getState().reset()
    },
    onClose: () => {
      useStyleTemplateEditorStore.getState().clearEditor()
      useStyleTemplateChatStore.getState().reset()
    },
  })

  const sidebarState = useContentSidebarStore.getState()
  if (
    !sidebarState.showConfirmDialog &&
    sidebarState.currentPanel?.id === "style-template-canvas"
  ) {
    useContentSidebarStore.setState({ isFocused: true })
  }
}

export function closeStyleTemplateInSidebar(): void {
  const sidebarStore = useContentSidebarStore.getState()
  if (sidebarStore.currentPanel?.id !== "style-template-canvas") {
    return
  }
  sidebarStore.closePanel()
}
